<template>
    <div style="height: 100%">
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="page">
                <div class="tipos-servicos vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t('ven-cliente-aba-formas-rcbto') }}
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{ $t('vendas') }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{ $t('cadastros') }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{
                                            $t('ven-cliente-aba-formas-rcbto')
                                        }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="permissao.create && !integracao"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="$router.push({ name: 'ven-forma-recebimento-new' })"
                            >
                                {{ $t('adicionar') }}
                            </button>
                        </div>
                    </div>

                    <div class="search-and-filter">
                        <div class="search-bar">
                            <search-bar :onSearch="debouncedOnSearch" />
                        </div>

                        <div class="replicapda-select">
                            <label v-text="$t('situacao')" />
                            <v-select
                                ref="replicapdaInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="onSituacaoChanged"
                                v-model="situacao"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="no-options">{{ $t('sem-resultados') }}</template>
                            </v-select>
                        </div>
                    </div>

                    <div class="registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="formasrecebimento"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="f.key != 'excluir' ? $t(f.key) : ''"
                                :width="f.width"
                                :class="{
                                    'excluir-field': f.key == 'excluir',
                                    'label-km': f.key == 'label',
                                }"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'descricao'">
                                    <router-link
                                        :to="{
                                            name: 'ven-forma-recebimento-edit',
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'excluir'">
                                    <b-button
                                        v-if="permissao.delete && !integracao"
                                        class="action-button"
                                        :type="
                                            props.row['situacao'] == 1 ? 'is-danger' : 'is-success'
                                        "
                                        :icon-right="
                                            props.row['situacao'] == 1 ? 'delete' : 'check'
                                        "
                                        @click="promptChangeSituacao(props.row)"
                                        v-tippy
                                        :title="
                                            $t(
                                                props.row['situacao'] == 1
                                                    ? 'desativar'
                                                    : 'reativar'
                                            )
                                        "
                                    />
                                </div>
                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-if="props.row[f.key] == 1"
                                        type="is-success"
                                        size="is-medium"
                                        >{{ $t('ativo') }}</b-tag
                                    >
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-else
                                        type="is-danger"
                                        size="is-medium"
                                        >{{ $t('inativo') }}</b-tag
                                    >
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import FormaRecebimentoService from '@/services/FormaRecebimentoService';
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes('ven-forma-recebimento') && to.name != 'ven-forma-recebimento-list') {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados();
            next();
        }
    },
    components: {
        ContainerLoader,
        HideInfo,
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('FORMARECEBIMENTO'),
            cleanHide: true,
            formasrecebimento: [],
            situacoes: [
                { id: 0, label: 'inativos' },
                { id: 1, label: 'ativos' },
                { id: 2, label: 'todos' },
            ],
            situacao: { id: 2, label: 'todos' },
            service: new FormaRecebimentoService(this.$http, this.$router),
            fields: [
                { key: 'codigo', width: '10%', sortable: true, sortFn: null },
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                { key: 'situacao', width: 70, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            delete: null,
            queryFilter: '',
            column: 'descricao',
            order: 'asc',
            permissao: {},
        };
    },
    created() {
        if (
            this.$route.name.includes('ven-forma-recebimento') &&
            this.$route.name != 'ven-forma-recebimento-list'
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess('vendas', 'vendas', 'ven-forma-recebimento');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'ven-cliente-aba-formas-rcbto' },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', { infoIsHidden: !this.hide.infoIsHidden });
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[2];
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            this.cleanHide = true;
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.formasrecebimento = value;
                    this.isEmpty = this.formasrecebimento.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os prazos.');
                })
                .finally((_) => {
                    this.cleanHide = false;
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let list = body.content.map((m) => {
                return {
                    id: m.id,
                    codigo: m.idformarecebimentoerp,
                    descricao: m.descricao,
                    datahorainc: m.datahorainc,
                    datahoraalt: m.datahoraalt,
                    situacao: m.situacao,
                    excluir: 'excluir',
                };
            });
            return list;
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? 'msg-sucesso-ao-desativar-forma-recebimento'
                    : 'msg-sucesso-ao-reativar-forma-recebimento';

            let tempFormaRecebimento = {
                idformarecebimento: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.service
                .updateSituacao(tempFormaRecebimento)
                .then((r) => {
                    if (r.status == 200) {
                        if (r.content.situacao == 1) {
                            this.$root.showMessage(
                                'success',
                                'msg-sucesso-ao-reativar-forma-recebimento'
                            );
                        } else if (r.content.situacao == 0) {
                            this.$root.showMessage(
                                'success',
                                'msg-sucesso-ao-desativar-forma-recebimento'
                            );
                        }
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    min-height: calc(100% - 50px);
    position: relative;

    .page {
        position: relative;
        padding-left: 0;

        .table-tag {
            width: 5rem !important;
        }

        .tipos-servicos .search-and-filter {
            display: flex;
            justify-content: space-between;
            margin: 10px 0;

            .search-bar {
                width: 80%;
                padding-right: 10px;
            }
            .replicapda-select {
                width: 30%;
                div {
                    height: 40px;
                }
            }
            .filter-bar {
                width: 31%;
            }
            @media (max-width: 760px) {
                .search-bar {
                    padding-right: 0;
                }
                .replicapda-select {
                    width: 100%;
                }
            }
        }
    }
}
</style>
